<template>
  <div class="mb-1">
    <v-row dense no-gutters>
      <span
        class="ml-1 font-capitalize caption"
        style="color: rgba(0,0,0,0.6)"
        >{{ item.nom }}</span
      >
    </v-row>
    <v-row dense no-gutters>
      <v-text-field
        filled
        dense
        hide-details
        class="no-before mr-1"
        style="width: 35px"
        type="number"
        min="0"
        :value="getValue(item, 'v1')"
        @change="v => setValue(item, 'v1', v)"
      ></v-text-field>
      <v-text-field
        ref="v1"
        filled
        dense
        hide-details
        class="no-before mr-1"
        style="width: 35px"
        type="number"
        min="0"
        :value="getValue(item, 'v2')"
        @change="v => setValue(item, 'v2', v)"
      ></v-text-field>
      <v-text-field
        ref="v2"
        filled
        dense
        hide-details
        class="no-before mr-1"
        style="width: 35px"
        type="number"
        min="0"
        :value="getValue(item, 'v3')"
        @change="v => setValue(item, 'v3', v)"
      ></v-text-field>
      <v-text-field
        ref="v3"
        filled
        dense
        hide-details
        class="no-before"
        style="width: 35px"
        type="number"
        min="0"
        :value="getValue(item, 'v4')"
        @change="v => setValue(item, 'v4', v)"
      ></v-text-field>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "InventoryItemAdder",
  props: {
    item: {
      required: true
    }
  },
  computed: {
    ...mapGetters(["getInventoryRecords"])
  },
  methods: {
    getValue(item, v) {
      const record = this.getInventoryRecords.find(
        x => x.fk_product === item.id
      );
      if (record) {
        return record[v];
      } else {
        return null;
      }
    },
    setValue(item, v, value) {
      const record = this.getInventoryRecords.find(
        x => x.fk_product === item.id
      );
      if (record) {
        record[v] = value;
        if (this.$refs[v]) {
          this.$refs[v].focus();
        }
      }
    }
  }
};
</script>

<style></style>
